// extracted by mini-css-extract-plugin
module.exports = {"back-button":"styles__back-button___bo2mm","audit-log-table":"styles__audit-log-table___2e3aZ","no-logs-message":"styles__no-logs-message___2KOMg"};